
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.387 5.893c1.04 0 2.343-.703 3.12-1.64.703-.85 1.215-2.037 1.215-3.223 0-.161-.014-.322-.043-.454-1.158.044-2.55.776-3.384 1.758-.66.747-1.26 1.918-1.26 3.12 0 .175.03.351.044.41.074.014.19.029.308.029zM8.725 23.616c1.42 0 2.05-.952 3.823-.952 1.802 0 2.197.923 3.779.923 1.553 0 2.593-1.436 3.574-2.842 1.098-1.611 1.552-3.193 1.582-3.266-.103-.03-3.076-1.245-3.076-4.658 0-2.959 2.343-4.292 2.475-4.394-1.552-2.226-3.91-2.285-4.555-2.285-1.743 0-3.164 1.055-4.057 1.055-.967 0-2.241-.996-3.75-.996-2.87 0-5.786 2.372-5.786 6.854 0 2.783 1.084 5.727 2.417 7.632 1.143 1.61 2.139 2.929 3.574 2.929z"}})])
          )
        }
      }
    